<template>
  <a-tooltip v-if="tooltipContent" :placement="tooltipPlacement">
    <template slot="title">
      <span v-html="tooltipContent" @click="handleTooltipClick"></span>
    </template>
    <a-button
      :class="buttonClasses"
      :type="type"
      :loading="isLoading"
      :disabled="isDisabled"
      @click.prevent="handleClick"
    >
      <slot v-if="useSlot" />
      <template v-else>
        <font-awesome-icon v-if="showPrefixIcon" class="icon" :icon="icon" />
        {{ buttonText }}
        <font-awesome-icon
          v-if="showSuffixIcon"
          class="icon m-left-5"
          :icon="icon"
        />
      </template>
    </a-button>
  </a-tooltip>
  <a-button
    v-else
    :class="buttonClasses"
    :type="type"
    :loading="isLoading"
    :disabled="isDisabled"
    @click.prevent="handleClick"
  >
    <slot v-if="useSlot" />
    <template v-else>
      <font-awesome-icon v-if="showPrefixIcon" class="icon" :icon="icon" />
      {{ buttonText }}
      <font-awesome-icon
        v-if="showSuffixIcon"
        class="icon m-left-5"
        :icon="icon"
      />
    </template>
  </a-button>
</template>

<script>
const BUTTON_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SECONDARY_SMALL: "secondary-small",
  DANGER: "danger",
  CTA: "cta",
  FORM: "form",
  DEFAULT: "",
};

export default {
  name: "BaseButton",
  props: {
    type: {
      type: String,
      default: BUTTON_TYPES.DEFAULT,
      validator: value => Object.values(BUTTON_TYPES).includes(value),
    },
    isRounded: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "none",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSuffixIcon: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "",
    },
    handleClick: {
      type: Function,
      required: true,
    },
    useSlot: {
      type: Boolean,
      default: false,
    },
    tooltipContent: {
      type: String,
      default: "",
    },
    tooltipPlacement: {
      type: String,
      default: "top",
    },
    handleTooltipClick: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    showPrefixIcon() {
      return this.icon !== "none" && !this.isSuffixIcon;
    },

    showSuffixIcon() {
      return this.icon !== "none" && this.isSuffixIcon;
    },
    buttonClasses() {
      return {
        button: true,
        "ant-btn-primary": this.type === BUTTON_TYPES.PRIMARY,
        "ant-btn-secondary": this.type === BUTTON_TYPES.SECONDARY,
        "ant-btn-secondary-small": this.type === BUTTON_TYPES.SECONDARY_SMALL,
        "ant-btn-decline": this.type === BUTTON_TYPES.ERROR,
        "btn--rounded": this.isRounded,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
button:disabled {
  opacity: 0.6;
}

::v-deep .ant-tooltip-inner a {
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
